package core.validation.validator

import core.dateformat.utils.parseLocalDateOrNull

class DateDoubleValidator(
    private val firstValueRequired: Boolean = false,
    private val secondValueRequired: Boolean = false,
) : DoubleValidator<String> {
    override val errorMessage: String
        get() = "Invalid date format."

    override fun validate(
        firstValue: String,
        secondValue: String,
    ): Pair<Boolean, Boolean> {
        val firstDate = parseLocalDateOrNull(firstValue)
        val secondDate = parseLocalDateOrNull(secondValue)
        return Pair(
            if (firstValueRequired)
                firstDate != null else
                (firstValue.isEmpty() || firstDate != null),
            if (secondValueRequired)
                secondDate != null else
                (secondValue.isEmpty() || secondDate != null),
        )
    }
}